import { render, staticRenderFns } from "./magCover.vue?vue&type=template&id=98cdedb0&scoped=true"
import script from "./magCover.vue?vue&type=script&lang=js"
export * from "./magCover.vue?vue&type=script&lang=js"
import style0 from "./magCover.vue?vue&type=style&index=0&id=98cdedb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cdedb0",
  null
  
)

export default component.exports